import React from 'react';
import { useNavigate } from 'react-router-dom';
import soodLogo from '../images/soodLogoHeader.png';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="logo-container">
          <img src={soodLogo} alt="Sood Foundation" className="not-found-logo" />
        </div>
        
        <div className="error-display">
          <h1 className="error-code">404</h1>
          <div className="error-message">
            <h2>Oops! Page Not Found</h2>
            <p>The page you're looking for seems to have wandered off. But don't worry, your generosity can still make a difference!</p>
          </div>
        </div>

        <div className="action-buttons">
          <button className="btn-home" onClick={handleGoHome}>
            Go Back Home
          </button>
        </div>

        <div className="help-text">
          <p>Need help? Contact us or return to our donation page to continue supporting our cause.</p>
        </div>
      </div>
      
      <div className="floating-elements">
        <div className="floating-circle circle-1"></div>
        <div className="floating-circle circle-2"></div>
        <div className="floating-circle circle-3"></div>
      </div>
    </div>
  );
};

export default NotFound;
